import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import {
    tierColorForToken,
    tierColorOptions,
} from "components/references/show-reference/tier-colors";
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from "lib/headlessui/components/menu/menu";
import React from "react";

interface TierColorPickerProps {
    name: string;
    color: string | null;
    onSelect: (token: string) => void;
}

const colorLabel = (token: string): string =>
    token.charAt(0).toUpperCase() + token.slice(1);

export const TierColorPicker: React.FC<TierColorPickerProps> = ({
    name,
    color,
    onSelect,
}) => {
    const current = tierColorForToken(color);
    return (
        <Menu as="div" className="relative inline-block text-left">
            <MenuButton
                title="Change color"
                className={`inline-flex items-center gap-1 rounded-full ${current.bg} ${current.text} px-3 py-0.5 text-sm font-medium`}>
                {name || "Tier"}
                <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
            </MenuButton>
            <MenuItems className="z-1300 absolute left-0 mt-2 max-h-72 w-44 overflow-auto rounded-md bg-white p-1 shadow-lg ring-1 ring-gray-200 focus:outline-none">
                {tierColorOptions.map(option => (
                    <MenuItem key={option.token}>
                        <button
                            type="button"
                            onClick={() => onSelect(option.token)}
                            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm text-gray-700 hover:bg-gray-100">
                            <span
                                className={`h-4 w-4 flex-shrink-0 rounded-full ${option.bg} ring-1 ring-inset ring-gray-300`}
                            />
                            <span className="flex-1">{colorLabel(option.token)}</span>
                            {option.token === current.token ? (
                                <CheckIcon
                                    className="h-4 w-4 text-brand-600"
                                    aria-hidden="true"
                                />
                            ) : null}
                        </button>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};
